import axios from "axios";
import { apiClient } from "./api";

export const tweeter_backendUrl = import.meta.env.PROD
  ? import.meta.env.VITE_REACT_APP_TWEETER_FASTAPI_URL_PRODUCTION
  : import.meta.env.VITE_REACT_APP_TWEETER_FASTAPI_URL_DEVELOPMENT;

// ==========================================
// API functions for Instagram account management
// ==========================================

export async function initiateInstagramLogin(
  personaId: string,
  redirectUrl: string,
): Promise<string> {
  try {
    const response = await axios.get(`${tweeter_backendUrl}/instagram/login`, {
      params: {
        persona_id: personaId,
        redirect_url: redirectUrl,
      },
    });

    const { authorization_url } = response.data;
    if (!authorization_url) {
      throw new Error("Authorization URL not returned from the server.");
    }

    return authorization_url;
  } catch (error: any) {
    console.error(
      `Error initiating Instagram login for agent ${personaId}: ${error.response?.data || error.message}`,
      error,
    );
    throw error;
  }
}

export async function initiateInstagramLogout(
  personaId: string,
): Promise<string> {
  try {
    const response = await apiClient.post(
      `/api/personas/${personaId}/instagram/logout`,
    );

    return response.data;
  } catch (error: any) {
    console.error(
      `Error initiating Instagram logout for agent ${personaId}: ${error.response?.data || error.message}`,
      error,
    );
    throw error;
  }
}

export async function postToInstagram(postId: string) {
  try {
    await apiClient.post(`/api/instagram/${postId}/post`);
  } catch (error) {
    console.error(`Error posting post with doc_id ${postId}:`, error);
    throw error;
  }
}
